import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Space, Tooltip, Avatar } from "antd";
import { GlobalOutlined, DownOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import "./translate-button.css";

function TranslateButton() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(() => {
    try {
      return localStorage.getItem("translate_lang") || "th";
    } catch (e) {
      return "th";
    }
  });

  useEffect(() => {
    // Inject Google Translate script only once
    if (!window.google || !window.google.translate) {
      window.googleTranslateElementInit = function () {
        /* global google */
        try {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "th",
              includedLanguages: "th,en,id,ar",
              layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            },
            "google_translate_element"
          );
        } catch (e) {
          // ignore
        }
      };

      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      document.body.appendChild(s);
    }
    // try to apply saved language when widget becomes available
    const applySaved = () => {
      const saved = localStorage.getItem("translate_lang") || "th";
      setCurrent(saved);
      const combo = document.querySelector(".goog-te-combo");
      if (combo && combo.value !== saved) {
        combo.value = saved;
        combo.dispatchEvent(new Event("change"));
      }
    };

    let poll;
    poll = setInterval(() => {
      if (document.querySelector(".goog-te-combo")) {
        applySaved();
        // hide any google translate banners that appear
        hideGoogleBanner();
        clearInterval(poll);
      }
    }, 300);

    return () => clearInterval(poll);
  }, []);

  const hideGoogleBanner = () => {
    try {
      const iframes = document.querySelectorAll('iframe.goog-te-banner-frame, iframe.goog-te-menu-frame');
      iframes.forEach((f) => (f.style.display = 'none'));
      const banners = document.querySelectorAll('.goog-te-banner-frame, .goog-te-menu-frame, .skiptranslate, .goog-te-gadget');
      banners.forEach((b) => (b.style.display = 'none'));
      const gb = document.getElementById('goog-gt-tt');
      if (gb) gb.style.display = 'none';
      document.body.style.top = '0px';
    } catch (e) {
      // ignore
    }
  };

  const location = useLocation();

  // Re-apply translation when route changes (SPA navigation)
  useEffect(() => {
    const applyTranslate = () => {
      const combo = document.querySelector(".goog-te-combo");
      const saved = localStorage.getItem("translate_lang") || "th";
      if (combo) {
        if (combo.value !== saved) combo.value = saved;
        combo.dispatchEvent(new Event("change"));
        setCurrent(saved);
        // hide banner after reapplying
        setTimeout(hideGoogleBanner, 200);
      }
    };

    // Small timeout to allow new content to render
    const t = setTimeout(() => {
      if (window.google && window.google.translate) {
        applyTranslate();
      }
    }, 300);

    return () => clearTimeout(t);
  }, [location]);
  const setLanguage = (lang) => {
    localStorage.setItem("translate_lang", lang);
    // Set googtrans cookie as a reliable fallback and reload to apply
    try {
      const src = "th";
      const cookieVal = `/" + src + "/" + lang`;
    } catch (e) {}

    // Set cookie in the format '/src/lang' (no quotes)
    const cookie = `/th/${lang}`;
    const expire = new Date();
    expire.setFullYear(expire.getFullYear() + 1);
    document.cookie = `googtrans=${cookie};expires=${expire.toUTCString()};path=/`;

    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = lang;
      combo.dispatchEvent(new Event("change"));
      setCurrent(lang);
      // small delay to allow change to apply, then ensure cookie is set
      setTimeout(() => {
        hideGoogleBanner();
        window.location.reload();
      }, 700);
    } else {
      // If widget not ready, reload so cookie takes effect on load
      setCurrent(lang);
      setTimeout(() => {
        hideGoogleBanner();
        window.location.reload();
      }, 300);
    }
  };

  const langs = [
    { code: "th", label: "ภาษาไทย", flag: "🇹🇭" },
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "id", label: "Bahasa Indonesia", flag: "🇮🇩" },
    { code: "ar", label: "العربية", flag: "🇸🇦" },
  ];

  const menu = (
    <Menu selectable selectedKeys={[current]} onClick={(e) => setLanguage(e.key)}>
      {langs.map((l) => (
        <Menu.Item key={l.code} icon={<span style={{ fontSize: 18 }}>{l.flag}</span>}>
          {l.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="translate-fab">
      <div id="google_translate_element" style={{ display: "none" }} />
      <Tooltip title="แปลภาษา">
        <Dropdown
          overlay={menu}
          trigger={["click"]}
          placement="topLeft"
          overlayClassName="translate-overlay"
          overlayStyle={{ maxHeight: "60vh", overflow: "auto", zIndex: 2000 }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Button
              size="small"
              type="primary"
              shape="circle"
              className="translate-fab-btn"
            >
              <GlobalOutlined style={{ fontSize: 18 }} />
            </Button>
            <span className="fab-label">
              <span style={{ marginRight: 6 }}>{langs.find((x) => x.code === current)?.flag}</span>
              <span>{langs.find((x) => x.code === current)?.label}</span>
            </span>
          </div>
        </Dropdown>
      </Tooltip>
    </div>
  );
}

export default TranslateButton;
